import { useNavigate } from 'react-router-dom';
import { isPathAccessible } from '../utils/permissions';

/**
 * Обгортка над useNavigate що мовчки блокує переходи
 * на сторінки, недоступні за правами поточного користувача.
 */
export function useCheckedNavigate(currentUser) {
  const navigate = useNavigate();

  return (to, options) => {
    const pathname = typeof to === 'string' ? to.split('?')[0] : to?.pathname;
    if (pathname && !isPathAccessible(pathname, currentUser)) {
      return;
    }
    navigate(to, options);
  };
}
